import { openBlock as o, createElementBlock as t, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 20"
}, r = /* @__PURE__ */ e("path", {
  stroke: "#141B34",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M.914 8.333c0-3.142 0-4.714 1.037-5.69 1.038-.976 2.707-.976 6.046-.976h.644c2.718 0 4.077 0 5.02.665q.407.287.713.67c.707.889.707 2.167.707 4.725V9.85c0 2.469 0 3.704-.391 4.69-.628 1.585-1.957 2.835-3.641 3.427-1.048.367-2.36.367-4.983.367-1.5 0-2.25 0-2.848-.21-.962-.338-1.722-1.052-2.08-1.958-.224-.564-.224-1.27-.224-2.68z"
}, null, -1), s = /* @__PURE__ */ e("path", {
  stroke: "#141B34",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15.083 10a2.78 2.78 0 0 1-2.777 2.778c-.555 0-1.21-.097-1.749.047-.48.129-.853.503-.982.982-.144.54-.047 1.194-.047 1.749a2.78 2.78 0 0 1-2.778 2.777M4.664 5.833h5.833M4.664 9.167h2.5"
}, null, -1), c = [
  r,
  s
];
function i(l, d) {
  return o(), t("svg", n, [...c]);
}
const a = { render: i };
export {
  a as default,
  i as render
};
